import React, { Component } from 'react';
import './Navbar.css';
import { AppBar, Toolbar, IconButton, Typography, Button, Menu, MenuItem } from "@material-ui/core";
import HomeIcon from '@material-ui/icons/Home';

import IconoModoClaro from '@material-ui/icons/Brightness7';
import IconoModoOscuro from '@material-ui/icons/Brightness4';

import logo from "../../logo02.webp";
import logoAlternativo from "../../logo01.webp";
import { Link, withRouter } from 'react-router-dom';

import { esEventoEspecial } from '../../config/eventosEspeciales';


class NavBar extends Component {

    constructor(props) {
        super(props)

        const guardado = localStorage.getItem('dh-tema')
        const oscuro = guardado
            ? guardado === 'dark'
            : document.body.classList.contains('dh-theme-dark')

        this.state = { modoOscuro: oscuro, pulso: true }
        this.alternarTema = this.alternarTema.bind(this)
    }

    componentDidMount() {
        this.aplicarTema(this.state.modoOscuro)
    }

    aplicarTema(oscuro) {
        document.body.classList.toggle('dh-theme-dark', oscuro)
        document.body.classList.toggle('dh-theme-light', !oscuro)
    }

    alternarTema() {
        const oscuro = !this.state.modoOscuro

        this.aplicarTema(oscuro)
        localStorage.setItem('dh-tema', oscuro ? 'dark' : 'light')
        this.setState({ modoOscuro: oscuro, pulso: false })
    }



    getLogo() {
        const eventId = this.props.match && this.props.match.params
            ? this.props.match.params.id
            : null;

        return esEventoEspecial(eventId) ? logoAlternativo : logo;
    }

    render() {
        return (
            
            <div className="container">
                <AppBar position="static">
                    <Toolbar>
                        <div className='logo_y_home_y_title'>
                            <div className="logo">
                                <Link to="/"><img className="logo-img" src={this.getLogo()}/></Link>
                            </div>
                            
                            <div className='homeIcon'>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    className={`themeIcon-btn ${this.state.pulso ? 'pulso' : ''}`}
                                    aria-label={this.state.modoOscuro ? "modo claro" : "modo oscuro"}
                                    onClick={this.alternarTema}
                                >
                                    {this.state.modoOscuro
                                        // ? <Brightness7Icon className='themeIcon-icon' style={{color: "#fff"}} />
                                        // : <Brightness4Icon className='themeIcon-icon' style={{color: "#fff"}} />
                                        
                                        ? <IconoModoClaro className='themeIcon-icon' style={{color: "#fff"}} />
                                        : <IconoModoOscuro className='themeIcon-icon' style={{color: "#fff"}} />
                                        
                                    }
                                </IconButton>

                                    
                                <IconButton edge="start" color="inherit" aria-label="menu">
                                    <Link to="/"><HomeIcon className='homeIcon-icon' style={{color: "#fff"}} /></Link>
                                </IconButton>
                            </div>

                            <div className='title'>
                                <Typography variant="h6" align="center" className="title-text">
                                    TIEMPOS ONLINE
                                </Typography>
                            </div>
                        </div>

                    </Toolbar>

                </AppBar>
                
            </div>

        );
    }
}
export default withRouter(NavBar);
